<template>
 <v-app>
    <div id="app">
      
        <vue3-confirm-dialog />
        <router-view />
      
    </div>
   
   
  </v-app>
</template>

<script>

/*eslint-disable*/
//import Vue from 'vue';
//import JsonExcel from 'vue-json-excel';
import * as Sentry from '@sentry/browser';
import { version } from '../package';
import AppSettings from './views/AppSettings.vue';
import  { refreshPage } from '@/services/Refresh-page';



//Vue.component('downloadExcel', JsonExcel);

export default {
  name: 'App',
  components: {
    AppSettings,
  },
  data: () => ({
    appVersion: version,
  }),
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      // SentryService.logMessage('Sentry environement testing');
      console.log('initialize');
      refreshPage.methods.startInterval('version.json', version);
      const sentrytag = localStorage.getItem('sentrytag');
      const userData = localStorage.getItem('usertData');
      if (sentrytag != undefined) {
        Sentry.configureScope((scope) => {
          scope.setTag('tenant', sentrytag);
        });
      }
      if (userData) {
        Sentry.configureScope((scope) => {
          scope.setTag('Username', userData.userEmail);
        });
      }

      Sentry.configureScope((scope) => {
        scope.setTag('Version', this.appVersion);
      });
    },
  },
};
</script>
<style>
/* eslint-disable */
@import url("https://fonts.googleapis.com/css?family=Roboto");

body {
  background: #fff;
  font-family: "Roboto", sans-serif;
}

#app {
  background: #fff;
}

.page {
  position: fixed;
  width: inherit;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.v-snack {  padding-left:40% !important; }
.v-snack__wrapper {
  top: 0px;
  position: fixed;

}
.v-snack__content {
  background: black !important;
  padding: 5px;
}
.row_expired
  {
    background: rgb(223, 221, 221);
  }
   .row_deleted
  {
    background: rgb(255, 232, 232);
  }

</style>
